// @flow
import React from "react"
import type Moment from "moment"
import type { DateRangeMoment } from "data/units/date/types"
import { dateStringFromMoment } from "data/units/date/helpers"
import type { ProductVariantAvailableAffiliate } from "data/product/types"
import { dayStatus } from "data/reservations/constants"
import type { DayStatus } from "data/reservations/types"
import { type Error as ErrorType } from "components/Calendar/ErrorMessage"
import DayPrice from "../DayPrice"
import { isActive } from "../helpers"
import { DayWrap, StyledDay } from "./styled"

type Props = {|
  variantAffiliate?: ProductVariantAvailableAffiliate,
  day: Moment,
  status: DayStatus,
  value: DateRangeMoment,
  onError?: ErrorType => mixed,
|}

const UnavailableDay = ({
  variantAffiliate,
  day,
  status,
  value,
  onError,
}: Props) => (
  <DayWrap onClick={onError ? () => onError(status) : null} status={status}>
    <StyledDay
      first={value && value.startDate && value.startDate.isSame(day, "day")}
      status={status}
      active={isActive(day, value)}
    >
      {day.date()}
    </StyledDay>
    {status !== dayStatus.blocked && status !== dayStatus.closedHidePrice && (
      <DayPrice day={dateStringFromMoment(day)} value={value} variantAffiliate={variantAffiliate} />
    )}
  </DayWrap>
)

export default UnavailableDay



// WEBPACK FOOTER //
// ./src/components/Calendar/Month/Day/UnavailableDay/index.js